import React from 'react';
import { Link } from 'react-router-dom';
import { FaAngleRight } from "react-icons/fa";
import BlogData from "../../data/blog/BlogData.json";


const allBlogData = BlogData;

const BlogListOne = ({colSize, itemShow, category, excludeId}) => {

    const listData = category
        ? allBlogData.filter(data => data.category === category && data.id !== excludeId)
        : allBlogData;

    return (
        <>
            {listData.slice(0, itemShow).map((data) => (
                <div className={`${colSize}`} key={data.id}>
                    <div className="blog-grid blog-grid-2 related-post-card">
                        <div className="post-thumbnail">
                            <Link to={process.env.PUBLIC_URL + `/blog-details/${data.slug}`}>
                                <img src={`${process.env.PUBLIC_URL}/${data.thumb}`} alt="Blog Post" loading="lazy" />
                            </Link>
                        </div>
                        <div className="post-content">
                            <h5 className="title">
                                <Link to={process.env.PUBLIC_URL + `/blog-details/${data.slug}`}>
                                    {data.title}
                                </Link>
                            </h5>
                            <p>{data.excerpt}</p>
                            <Link to={process.env.PUBLIC_URL + `/blog-details/${data.slug}`} className="axil-btn btn-borderd">
                                Learn more <FaAngleRight />
                            </Link>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}

export default BlogListOne;